import { useState } from "react";
import { useSelector } from "react-redux";
import "./Email.css";
import EmailList from "./EmailList";
import EmailViewer from "./EmailViewer";
import LandingChat from "../Chat/LandingChat";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import {
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";

import { Icon } from "@iconify/react/dist/iconify.js";

const Email = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [anchorElMore, setAnchorElMore] = useState(null);

  // For assigning multiple emails
  const [isAssigningEmails, setIsAssigningEmails] = useState(false);

  const [isBack, setIsBack] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const { myInfo } = useSelector((state) => state.auth);
  const level = myInfo.user.Level;
  const openMore = Boolean(anchorElMore);

  return (
    <div className="WholeEmail">
      <div className="listMain">
        <div className="list_header_email">
          <div className="list_headerLeft">
            <h1>Email</h1>
          </div>

          {level !== 0 && (
            <div className="list_headerRight">
              <Tooltip
                title="Assign email. Only available in assigned and queued tab"
                arrow
              >
                <IconButton
                  onClick={() =>
                    (activeTab === 1 || activeTab === 2) &&
                    setIsAssigningEmails(true)
                  }
                >
                  <Icon height="30" icon="mdi:message-check-outline" />
                </IconButton>
              </Tooltip>

              <Menu
                anchorEl={anchorElMore}
                className="messages-menu"
                id="Message_action"
                open={openMore}
                onClose={() => setAnchorElMore(null)}
                onClick={() => setAnchorElMore(null)}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <Tooltip title="Messages menu" arrow>
                  <MenuItem disabled onClick={() => setIsAssigningEmails(true)}>
                    <ListItemIcon>
                      <Icon height="30" icon="mdi:message-check-outline" />
                    </ListItemIcon>
                    Assign Emails
                  </MenuItem>
                </Tooltip>
              </Menu>
            </div>
          )}
        </div>

        <div className="email-list-container">
          <EmailList
            activeTab={activeTab}
            isAssigningEmails={isAssigningEmails}
            selectedEmail={selectedEmail}
            setActiveTab={setActiveTab}
            setSelectedEmail={setSelectedEmail}
            setIsAssigningEmails={setIsAssigningEmails}
            setIsBack={setIsBack}
          />
        </div>
      </div>

      <LandingChat />

      {selectedEmail && (
        <EmailViewer
          selectedEmail={selectedEmail}
          isBack={isBack}
          setIsBack={setIsBack}
        />
      )}
    </div>
  );
};

export default Email;
